import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { I18NService } from '@ebw-monorepo/i18n-translate';
import { EbwModalService } from '@ebw-monorepo/modal';
import { UtilsService } from '@ebw-monorepo/utils';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'ebw-monorepo-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss']
})
export class PasswordRecoveryComponent {
  recoveryForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<PasswordRecoveryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { url: string; user_id: string },
    private utilsSrv: UtilsService,
    private translateService: I18NService,
    private ebwModal: EbwModalService
  ) {
    this.recoveryForm = new FormBuilder().group({
      username: ['', [Validators.required]],
      email: ['', [Validators.required]]
    });
  }

  async recovery() {
    try {
      const controls = this.recoveryForm.controls;

      if (!this.data.url) {
        console.warn('[PasswordRecoveryComponent][recovery] path di password recovery not found');
        return;
      }

      if (!this.recoveryForm.valid) {
        this.recoveryForm.markAllAsTouched();
        return;
      }

      const body = new HttpParams()
        .set('username', controls.username.value)
        .set('email', controls.email.value)
        .set('grant_type', 'implicit')
        .set('client_id', 'web')
        .set('client_secret', 'secret');

      const HEADERS = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      });

      const request = this.utilsSrv.postRequestNoAuth(this.data.url, body, false, { headers: HEADERS });
      const response = (await lastValueFrom(request)) as { message: string };

      const title = this.translateService.getInstantValue('login.recovery_password');
      const content = response.message;
      const successModal = this.ebwModal.openSuccessModal({ title, content }).afterClosed();
      await lastValueFrom(successModal);
      this.dialogRef.close(true);
    } catch (error: any) {
      const title = this.translateService.getInstantValue('login.recovery_password');
      const content = error?.error?.message;
      const errorModal = this.ebwModal.openErrorModal({ title, content }).afterClosed();
      await lastValueFrom(errorModal);
    }
  }
}
